import isBuffer from 'is-buffer';
const { toString } = Object.prototype;
const isString = (val) => typeof val === 'string';
const isNumber = (val) => typeof val === 'number';
const isBoolean = (val) => typeof val === 'boolean';
const isUndefined = (val) => typeof val === 'undefined';
const isDate = (val) => toString.call(val) === '[object Date]';
const isFile = (val) => toString.call(val) === '[object File]';
const isBlob = (val) => toString.call(val) === '[object Blob]';
const isArray = (val) => toString.call(val) === '[object Array]';
const isObject = (val) => val !== null && typeof val === 'object';
const isFunction = (val) => typeof val === 'function';
const isStream = (val) => isObject(val) && isFunction(val.pipe);
const isArrayBuffer = (val) => toString.call(val) === '[object ArrayBuffer]';
const isFormData = (val) => typeof FormData !== 'undefined' && val instanceof FormData;
const isURLSearchParams = (val) => typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
    }
    else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    }
    return result;
}
function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' &&
        (navigator.product === 'ReactNative' ||
            navigator.product === 'NativeScript' ||
            navigator.product === 'NS')) {
        return false;
    }
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
const isHeaders = (headers) => toString.call(headers) === '[object Headers]';
const isResponse = (val) => toString.call(val) === '[object Response]';
const isPromise = (val) => toString.call(val) === '[object Promise]';
function combineURLs(baseURL, relativeURL) {
    return relativeURL
        ? `${baseURL.replace(/\/+$/, '')}/${relativeURL.replace(/^\/+/, '')}`
        : baseURL;
}
function queryFormat(obj) {
    return Object.entries(obj)
        .map(([key, value]) => value !== undefined && `${key}=${encodeURIComponent(value)}`)
        .filter(item => item)
        .join('&');
}
function addParams(url, params = {}) {
    const queryString = queryFormat(params);
    return queryString.length
        ? `${url}${url.includes('?') ? '&' : '?'}${queryString}`
        : url;
}
/**
 * 解析 email, 通过 '@' 分割为邮箱名和邮箱域名后缀
 *
 * @example const [prefix, suffix] = parseEmail(`linjiajian.999@bytedance.com`);
 */
const parseEmail = (email, suffixWithAtSymbol = false) => {
    if (!email) {
        return ['', ''];
    }
    const index = email.lastIndexOf('@');
    if (index < 0) {
        return [email, ''];
    }
    const prefix = email.slice(0, index);
    const suffix = email.slice(suffixWithAtSymbol ? index : index + 1);
    return [prefix, suffix];
};
export { addParams, combineURLs, parseEmail, queryFormat, isDate, isFile, isBlob, isArray, isStream, isNumber, isString, isObject, isBuffer, isBoolean, isFormData, isFunction, isUndefined, isArrayBuffer, isURLSearchParams, isArrayBufferView, isStandardBrowserEnv, isHeaders, isResponse, isPromise, };
//# sourceMappingURL=index.js.map